import type { EmptyListViewProps } from './components/MailListEmptyState';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailListEmptyState"*/ './lazyIndex'),
    { name: 'MailListEmptyState' }
);

// components
export { default as MailListShimmerState } from './components/MailListShimmerState';

// lazy components
export const MailListEmptyState: LazyComponent<EmptyListViewProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MailListEmptyState);
